<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      title="选择出生日期"
      id-key="Id"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="()=>{}"
      :get-data-func="()=>{}"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="出生日期" prop="birth">
              <el-date-picker v-model="data.birth" type="date" value-format="yyyy-MM-dd" placeholder="请选择出生日期" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Id: 0,
        birth: "",
      },
      isMB: this.$store.state.isMB,
      rules: {
        birth: [{ required: true, message: "请选择出生日期" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      this.data.birth = data.bd;
    },
    onEditOpened(data) {
      
    },
    toSave() {
      this.$emit("set-birth",this.data.birth);
      this.close(true);
    },
    onBeforeSave() {
      return false;
    },
    onClosed() {
      
    },
  }
};
</script>
<style lang="scss">
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .el-input,.el-select {
    width: 100%;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 18px;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  .el-checkbox__inner::after {
    height: 8px;
    left: 5px;
  }
  .el-checkbox__label {
    font-size: 16px;
    color: #000;
  }
  .red-inp {
    .el-input__inner::placeholder {
      color: #f11;
    }
  }
  .grade {
    width: 8%;
  }
  .radio-box {
    margin-right: 5rem;
    display: inline-block;
    text-align: left;
    padding:0.2rem 0;
    .el-radio__label {
      font-size: 16px;
    }
  }
}
.statusText {
  color:#F11;
  float:left;
  font-weight: bold;
  line-height: 34px;
  margin-left: 8px;
  font-size: 16px;
}
.zm3 {
  font-size: 16px;
  margin-top: 5px;
}
.rq:before {content: '* ';color: red;}
</style>